export default __webpack_public_path__ + "static/allie-sniffing-d2595f032c6f4f1669f49146712f9b59.jpeg";